// GSM 03.38 basic + extension table (chars extension count as 2 septets)
const GSM7_BASIC = new Set(
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\u001BÆæßÉ !\"#¤%&'()*+,-./" +
  "0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà"
    .split("")
);

const GSM7_EXT = new Set("^{}\\[~]|€".split("")); // extension table

function isGsm7(text: string): boolean {
  for (const ch of text) {
    if (GSM7_BASIC.has(ch) || GSM7_EXT.has(ch)) continue;
    return false; // Unicode
  }
  return true;
}

function gsm7SeptetLength(text: string): number {
  // extension chars count as 2 (escape + char)
  let len = 0;
  for (const ch of text) {
    if (GSM7_EXT.has(ch)) len += 2;
    else len += 1;
  }
  return len;
}

export function smsCount(text: string) {
  const gsm7 = isGsm7(text);

  if (gsm7) {
    const septets = gsm7SeptetLength(text);
    const single = 160;
    const concat = 153;

    const segments =
      septets <= single ? 1 : Math.ceil(septets / concat);

    const usedInCurrent =
      segments === 1 ? septets : septets - (segments - 1) * concat;

    const perSegment = segments === 1 ? single : concat;
    const remaining = perSegment - usedInCurrent;

    return {
      encoding: "GSM-7",
      length: septets,          // “true” SMS counter
      segments,
      remaining,
      perSegment
    };
  } else {
    // Unicode (UCS-2)
    const chars = Array.from(text).length; // correctly counts emoji/astral characters
    const single = 70;
    const concat = 67;

    const segments =
      chars <= single ? 1 : Math.ceil(chars / concat);

    const usedInCurrent =
      segments === 1 ? chars : chars - (segments - 1) * concat;

    const perSegment = segments === 1 ? single : concat;
    const remaining = perSegment - usedInCurrent;

    return {
      encoding: "Unicode",
      length: chars,
      segments,
      remaining,
      perSegment
    };
  }
}